/**
 * Axios instance s api-key header + JWT interceptorem.
 */

import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,       // session cookies pro service portal
  headers: {
    'api-key': process.env.VUE_APP_API_KEY
  }
});

instance.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const verifyToken = async () => {
  try {
    const { data } = await instance.get('/token');
    return data;
  } catch { return false; }
};

export default instance;
